export const GET_USER_LIST = 'user/list/get';
export const EDIT_USER = 'user/edit';
export const DELETE_USER = 'user/delete';
export const ADD_USER = 'user/add';
export const ADD_USER_CREDITS = 'user/credits/add';